import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';

function IconButton(props) {
  const { children, className, classes, disabled, onClick } = props;

  return (
    <button
      type="button"
      className={classNames(
        classes.root,
        classes.reset,
        { [classes.buttonDisabled]: disabled },
        className,
      )}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

IconButton.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

IconButton.defaultProps = {
  className: undefined,
  disabled: false,
};

const stylesheet = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    padding: 0,
    borderRadius: '50%',
    '&:hover': {
      opacity: theme.opacity.hover,
    },
  },
  reset: {
    margin: 0,
    padding: 0,
    width: 'auto',
    border: 'none',
    outline: 'none',
    color: 'inherit',
    font: 'inherit',
    fontFamily: 'inherit',
    fontSize: '100%',
    overflow: 'visible',
    lineHeight: 1.15,
    textTransform: 'none',
    backgroundColor: 'transparent',
  },
  buttonDisabled: {
    opacity: theme.opacity.disabled,
    pointerEvents: 'none',
  },
});

export default injectSheet(stylesheet)(IconButton);



// WEBPACK FOOTER //
// ./src/site-render/src/IconButton/IconButton.js